// extracted by mini-css-extract-plugin
export default {"showInfoButton":"RegistrationStep_showInfoButton__-qapb","imageWrapper":"RegistrationStep_imageWrapper__vEkH0","applicationImage":"RegistrationStep_applicationImage__h5gmH"};